import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import interceptorsSetup from './router/interceptores';
interceptorsSetup()
import axios from 'axios'
// let back = window.location.host == 'https://digi.grupof23.com' ? 'https://apidigiturnorentado.grupof23.com/public/' : 'https://apidigiturnorentado.grupof23.com/public/';
let back = window.location.host == 'https://capreturno.com' ? 'https://api.capreturno.com/public/' : 'https://api.capreturno.com/public/';
// let back = window.location.host == 'localhost:8080' ? 'https://api.capreturno.com/public/' : 'https://api.capreturno.com/public/';
axios.defaults.baseURL = back
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
// appInstance.use(axios);
appInstance.use(VueSweetalert2);
appInstance.mount("#app");
